import { type EditorPlugin } from '../../types/aha-editor';

const EmbeddedWhiteboardSchemaPlugin: EditorPlugin = {
  name: 'Embedded whiteboard schema',
  schema: {
    'embedded-whiteboard': {
      isVoid: true,
    },
    'embedded-whiteboard-placeholder': {
      isVoid: true,
    },
  },
};

export default EmbeddedWhiteboardSchemaPlugin;
